import CommentView from 'backbone/story/views/comments/comment_view.js'
import CommentFormView from 'backbone/story/views/comments/comment_form_view.js'
import CommentUtils from 'utils/story/comment_utils.js'
import InlineCommentUtils from 'utils/story/inline_comment_utils.js'

export default class CommentViewMediator extends Backbone.View
  initialize: ->
    @$commentPlaceholder = $(".js-comment-placeholder")
    @inlineCommentUtils = new InlineCommentUtils()
    @views = []

    $(window).keyup (event) =>
      @onEscClick() if event.which == 27
    $("body").click (event) =>
      @onBodyClick(event)

    @commentCollection = page.get("storyComments")
    @listenTo(@commentCollection, "add", @onCommentAdd)

  registerView: (view) ->
    @views.push(view)

  unregisterView: (view) ->
    indexOfView = @views.indexOf(view)
    if indexOfView != -1
      @views.splice(indexOfView, 1)

  showInlineComment: (options) ->
    @removeCommentForm()
    @removeCommentView()

    @view = options.view
    @comment = options.comment
    @offset = options.offset

    @commentView = new CommentView(
      comment: @comment
      top: @offset
      expanded: true
      active: true
    )

    @$commentPlaceholder.append(@commentView.$el)
    @commentView.render()
    @commentView.focusOnReplyBox()
    @commentCollection.setActive(@comment) unless @comment.isActive()
    @view.onViewOpen(@comment)

  onCommentAdd: (comment) ->
    for view in @views
      if view.commentInView(comment)
        view.openCommentView(comment)

  sidebarCommentClicked: (comment, isEditing) ->
    @removeCommentForm()
    @removeCommentView()
    for view in @views
      if view.commentInView(comment)
        view.openCommentView(comment)
        if isEditing
          @commentView.renderEditView(comment)

  displayAnchored: (comment) ->
    !window.location.href.match(/compare/) &&
      (comment.isInlineAnchored() || comment.isVideoAnchored() || comment.isImageAnchored())

  removeCommentView: ->
    @commentCollection.removeActive()
    if @commentView?
      @commentView.remove()
      @commentView = null
      @view.onViewClose(@comment)
      @view = null

  renderCommentForm: (options) ->
    @removeCommentView()
    @removeCommentForm() unless options.view.image

    @view = options.view
    @commentFormView = new CommentFormView(
      top: options.offset
      storyId: window.story.id
      inline: options.inline || false
      video: options.video || false
      image: options.image || false
      startTime: options.startTime
      endTime: null
      shape: options.shape
      assetId: options.assetId
      markId: options.markId
      highlightedText: options.highlightedText
      provisionalMarks: options.provisionalMarks
      text_model_type: options.text_model_type
      text_model_id: options.text_model_id
      text_model_attribute: options.text_model_attribute
    )

    @$commentPlaceholder.append(@commentFormView.$el)
    @commentFormView.$commentBodyField.focus()

  removeCommentForm: ->
    if @commentFormView?
      @commentFormView.remove()
      @commentFormView = null
      @view.onCommentFormClose()
      @view = null
    else
      @closeCommentingExtras()

  closeCommentingExtras: ->
    for view in @views
      if view.inline
        view.removeCommentButton()
      if view.image
        view.onCommentFormClose()

  onBodyClick: (e) =>
    return if !@commentCollection.fetched
    return if CommentUtils.isTextCompleteClick(e)
    return if CommentUtils.allowClicks(e)
    return if @commentInProgress()
    @removeCommentForm()
    @removeCommentView(@comment)

  onEscClick: =>
    @removeCommentView(@comment)
    @removeCommentForm()

  commentInProgress: ->
    CommentUtils.commentInProgress((@commentFormView || {}).$el)



// WEBPACK FOOTER //
// ./app/javascript/backbone/story/views/comments/comment_view_mediator.js.coffee